module.exports = __webpack_public_path__ + "img/main.439c1cc3.png";